/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo } from 'react';
import classNames from 'classnames';
import ReactEcharts from 'echarts-for-react';
import { renderGradeColour } from '../../utils';

import './NatCatChart.scss';

const NatCatChart = ({ data = [], direction = 'vertical', showTitle = true, title, onChartReady, print = false }) => {
  const chartData = {
    name: data?.map((p) => p.name),
    riskGrade: data?.map((p) => p.analysis.graph_value),
  };

  const vertical = direction === 'vertical';

  const xAxis = {
    type: 'category',
    data: chartData?.name,
    axisTick: {
      show: false,
    },
    axisLine: {
      show: false,
    },
    axisLabel: {
      width: 14,
      rotate: vertical ? 45 : 0,
      align: 'right',
      verticalAlign: 'middle',
      fontFamily: 'sans-serif',
      fontSize: 12,
    },
  };
  const yAxis = {
    type: 'value',
    show: false,
    max: 100,
    min: 0,
  };

  const option = {
    title: {
      show: showTitle,
      text: title || 'Natural Catastrophe Layer Analysis',
      left: 'center',
      top: 40,
      textStyle: { color: '#003262', fontSize: 16 },
    },
    grid: {
      top: showTitle ? 100 : 10,
      left: vertical ? '10%' : '5%',
      right: vertical ? '10%' : '5%',
      bottom: '5%',
      containLabel: true,
    },
    xAxis: vertical ? xAxis : yAxis,
    yAxis: vertical ? yAxis : xAxis,
    series: [
      {
        type: 'bar',
        barGap: '-100%',
        barCategoryGap: '40%',
        animation: false,
        data: chartData.name?.map(() => 100),
        itemStyle: {
          normal: { color: '#f1f4fb' },
          emphasis: { color: '#f1f4fb' },
        },
        barWidth: vertical ? null : 18,
      },
      {
        type: 'bar',
        z: 3,
        animation: !print,
        data: chartData?.riskGrade,
        itemStyle: {
          color: ({ dataIndex }) => renderGradeColour(data[dataIndex]?.analysis?.risk_description),
        },
        barWidth: vertical ? null : 18,
        label: {
          show: true,
          position: vertical ? 'top' : 'right',
          formatter: ({ dataIndex }) => {
            return data[dataIndex]?.analysis?.risk_description
              ? `{${data[dataIndex]?.analysis?.risk_description?.toLowerCase()}|${
                  data[dataIndex]?.analysis?.risk_description
                }}`
              : '';
          },
          rich: {
            high: { color: '#000' },
            medium: { color: '#000' },
            low: { color: '#000' },
          },
        },
      },
    ],
  };

  return (
    <div
      className={classNames('natcat-layer-chart')}
      style={vertical ? null : { height: data.length * 120, minHeight: 300 }}
    >
      <ReactEcharts
        option={option}
        notMerge
        onChartReady={onChartReady}
        style={vertical ? { height: '100%' } : { height: '80%' }}
        onEvents={{
          ...(!print && {
            click: ({ dataIndex }) => {
              document.getElementById(data[dataIndex].id).scrollIntoView({ behavior: 'smooth' });
            },
          }),
        }}
      />
    </div>
  );
};

export default memo(NatCatChart);
